import React from 'react'
import { Button, Row, Col, Card, Tag } from 'antd'
import styles from './TaskItem.module.scss'
import { SpotItem } from '..'
import { useComponentLocale } from '../../hooks/useComponentLocale'
import useWindowSizes from '../../hooks/useWindowSizes'

export default function TaskItem({
	item,
	onButtonStatusClicked,
	isRunEnabled,
	isRemoveEnabled,
	onButtonLogClicked,
	status,
	spots,
}) {
	const getLocale = useComponentLocale()
	const runLocale = getLocale({ component: 'common_buttons', section: 'run' })
	const logLocale = getLocale({ component: 'common_buttons', section: 'log' })
	const removeLocale = getLocale({ component: 'common_buttons', section: 'remove' })
	const handsLocale = getLocale({ component: 'common', section: 'hands' })
	const dataUploadLocate = getLocale({ component: 'uploadPage', section: 'date_upload' })
	const totalLocate = getLocale({ component: 'uploadPage', section: 'total' })

	const { windowWidth } = useWindowSizes()

	const dateOfItem = new Date(item.job_time).toLocaleDateString('en-GB', {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
	})

	const getTagColor = (status) => {
		switch (status) {
			case 'Done':
				return 'success'
			case 'Parsed':
			case 'Running':
				return 'processing'
			case 'Error':
				return 'error'
		}
	}

	return (
		<Card className={styles.card} bordered={false} bodyStyle={{ padding: 20, marginBottom: 10 }}>
			<Row justify='space-between' className={styles.taskInfoContainer}>
				<Col>
					<div className={styles.taskInfoItem}>
						{dataUploadLocate}: {dateOfItem}
					</div>
					<div className={styles.taskInfoItem}>
						{totalLocate} {item.hands_count} {handsLocale}
					</div>
				</Col>

				<Col>
					<div className={styles.taskInfoItem}>ID {item.job_id}</div>
					<div className={[styles.tagContainer, styles.taskInfoItem].join(' ')}>
						<Tag color={getTagColor(status)}>{status}</Tag>
					</div>
				</Col>
			</Row>

			<Row className={styles.progressInfoContainer}>
				{spots.map((spot) => (
					<SpotItem jobId={item.job_id} key={spot.spot_name} {...spot} status={status} />
				))}
			</Row>

			<Row gutter={[10, 10]} justify='end'>
				<Button
					className={styles.btn}
					onClick={() => onButtonStatusClicked(item.job_id, 'deleted')}
					disabled={!isRemoveEnabled}
				>
					{removeLocale}
				</Button>
				<Button className={styles.btn} onClick={() => onButtonLogClicked(item.hands_log)}>
					{logLocale}
				</Button>
				<Button
					className={styles.btn}
					onClick={() => onButtonStatusClicked(item.job_id, 'to_calc')}
					disabled={!isRunEnabled}
				>
					{runLocale}
				</Button>
			</Row>
		</Card>
	)
}
